export const faqGeneralData = [
    {
      tabHeader: "What is Pamo?",
      tabContent: [
        "Pamo is a buyer-led mobile commerce (m-commerce) platform that allows buyers to post items they wish to buy at the prices they are willing to pay. Merchants who have these items then make an offer and reach a deal with the buyer. Merchants can also create a shop on the app where they can upload their items to a catalogue, so buyers can shop from it."
      ]
    },
    {
      tabHeader: "Logging in or signing up for the app",
      tabContent: [
        {
          point: "How do I download the app?",
          detail: "Go to the app store on iOS or Google Play on Android. Search for the Pamo app. Locate the app in the search results. Tap on Get or Install to download and get started."
        },
        {
          point: "How do I sign up?",
          detail: "Tap on the Profile icon at the bottom navigation on the home page and follow prompts to sign up as an individual or a business."
        },
        {
          point: "What are the requirements to sign up?",
          detail: "To sign up as an individual, you will need to enter your full name and phone number. To sign up as a business, an email is required in addition to the business name and contact number. You will receive a One Time Password (OTP) via SMS on the phone number provided. The OTP will subsequently be collected as part of the registration process. You will also receive a code in your email to verify that your email is correct. This is important so you can receive future important updates and tips from Pamo. However, you can opt out of receiving such email updates by tapping unsubscribe in the mobile application."
        },
        {
          point: "What is a One Time Password (OTP)?",
          detail: "A One Time Password (OTP) is a temporary secure code sent to your number via SMS. This is used to confirm that the contact number you provided during registration belongs to you. You will be required to enter the OTP in the application anytime you receive it via SMS. Entering the correct OTP proves that the contact number the OTP was sent belongs to you."
        },
        {
          point: "How do I log in?",
          detail: "Tap Log in from the side menu, enter the phone number used to sign up, and the PIN chosen at sign-up."
        },
        {
          point: "What do I do if I forgot my PIN?",
          detail: "Select Forgot PIN on the login page. You will receive an OTP (One Time PIN) via SMS. Enter the OTP, choose and confirm a new PIN."
        },
        {
          point: "What happens if my OTP expires, or I do not receive it?",
          detail: "You can request the OTP to be resent."
        }
      ]
    },
    {
      tabHeader: "Live chat with an agent",
      tabContent: [
        {
          point: "I've looked at the FAQs but my issue is still not fixed. I want to talk to a customer support person?",
          detail: "You can live chat with someone from the Pamo support team by going to the sidebar in the app and clicking Settings and then Live Chat to talk to an agent on Whatsapp. This will redirect you to WhatsApp to talk to customer support. You can also call +233 599 203040."
        }
      ]
    },
  ];